module.exports = __webpack_public_path__ + "img/flomhendelser.8ae755ee.jpg";